import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTranslation } from "react-i18next";
import DevelopmentArea from "./DevelopmentArea";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import { useHistory } from "react-router-dom";
import Settings from "./Settings";
import Util from "../../Util";

const UBER_ADMIN = "UBER_ADMIN";

const EditCurriculum = (props) => {
  const data = props.location.state;
  console.log(data);
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("Subjects");
  const history = useHistory();
  const user = Util.getUser();
  const userSchoolRoles = user?.user_Schools?.map(
    (userSchool) => userSchool?.role?.reference
  );

  const isUberAdmin = userSchoolRoles.includes(UBER_ADMIN);

  const tabsStyle = {
    "& .MuiTabs-indicator": {
      backgroundColor: "#6418c3",
    },
  };

  const tabStyle = {
    textTransform: "none",
    fontSize: "14px",
    "&.Mui-selected": {
      color: "#6418c3",
      fontWeight: "600",
    },
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="body">
          <div className="col-md-12 p-3">
            {!data.isAdmin && (
              <BreadCrumbComponent
                Breadcrumb={[
                  {
                    name: "Admin Dashboard",
                    navigate: () => {
                      history.push("/admin");
                    },
                  },
                  {
                    name: "Assessments Templates",
                    navigate: () => {
                      history.push({ pathname: "/admin", tab: "TEMPLATES" });
                    },
                  },
                  { name: `${t(data?.data?.name)}` },
                ]}
              />
            )}
            {data.isAdmin && (
              <BreadCrumbComponent
                Breadcrumb={[
                  {
                    name: "Curriculum Framework",
                    navigate: () => {
                      history.push({ pathname: "/curriculum-framework" });
                    },
                  },
                  { name: `${t(data?.data?.name)}` },
                ]}
              />
            )}
            <h2 className="page-head">{data?.data?.name}</h2>
            <div className="row pb-3">
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                sx={tabsStyle}
              >
                <Tab sx={tabStyle} value="Subjects" label="Subjects" />
                <Tab sx={tabStyle} value="Settings" label="Settings" />
              </Tabs>

              <div className="pt-3">
                {selectedTab === "Subjects" && (
                  <DevelopmentArea data={data.data.id} />
                )}
                {selectedTab === "Settings" && <Settings data={data.data} isAdmin={data.isAdmin}/>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCurriculum;
